import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
  export class PageLoadingService {
    // Used to display the loading screen overlay on manage-my-membership pages
    public pageLoaded$ = new BehaviorSubject<boolean>(false);
        get pageLoaded() {return this.pageLoaded$.getValue();}
        set pageLoaded(value: boolean) {this.pageLoaded$.next(value);}

    public loadingItem: string = '';

    constructor (
      private router: Router,
      private route: ActivatedRoute
    ){
      // pass-selection, site-landing, pass-payment, receipt, and manage-my-membership pages all directly leverage the loading service
      // all other pages only activate the loading screen through above route and router event listeners 

      this.router.events.subscribe(async (event) => {
        if(event instanceof NavigationStart){
          this.pageLoaded$.next(false);
        } else if(event instanceof NavigationEnd){
          // Because of the amount of data that needs loaded on manage-my-membership pages, they handle loading screen deactivation in their components
          if(!event.url.includes("manage-my-membership") && !event.url.includes("pass-selection")){
            this.pageLoaded$.next(true);
          }
        }
      })
    }
  }